import { AmericanFootballIcon, BaseballIcon, BasketballIcon, CricketIcon, SoccerIcon } from "@/components/Icons";
import type { SportIcon } from "@roman/shared/types/SportIcon";

export type League = {
  seasonId: string;
  name: string;
  flag?: string;
};

export const LEAGUES: League[] = [
  {
    seasonId: "all",
    name: "ALL",
  },
  {
    seasonId: "sr:season:118689",
    name: "Premier League",
    flag: "🇬🇧",
  },
  {
    seasonId: "sr:season:118693",
    name: "Bundesliga",
    flag: "🇩🇪",
  },
  {
    seasonId: "sr:season:118691",
    name: "LaLiga",
    flag: "🇪🇸",
  },
  {
    seasonId: "sr:season:118975",
    name: "Serie A",
    flag: "🇮🇹",
  },
  {
    seasonId: "sr:season:119835",
    name: "Ligue 1",
    flag: "🇮🇹",
  },
  {
    seasonId: "sr:season:119239",
    name: "UEFA Champions League",
    flag: "🌎",
  },
  {
    seasonId: "sr:season:114057",
    name: "MLS",
  },
];

export type Sport = {
  id: number;
  icon: React.FC<SportIcon>;
};

export const SPORTS: Sport[] = [
  {
    id: 1,
    icon: SoccerIcon,
  },
  {
    id: 2,
    icon: AmericanFootballIcon,
  },
  {
    id: 3,
    icon: BasketballIcon,
  },
  {
    id: 4,
    icon: BaseballIcon,
  },
  {
    id: 5,
    icon: CricketIcon,
  },
];
